module.exports = __webpack_public_path__ + "static/media/IMG-4.e171b90b.jpg";